'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import Observer from '../../../lib/vendor/IntersectionObserver';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_LOADING_WRAPPER_HEIGHT = 300;
const LoadingDiv = styled.div.withConfig({
  displayName: "LazyLoadWrapper__LoadingDiv",
  componentId: "sc-15pwzww-0"
})(["height:", "px;"], props => props.height);
class LazyLoadWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isIntersecting: false,
      didIntersect: false
    };
    this.handleChange = ({
      isIntersecting
    }) => {
      const didIntersect = this.state.didIntersect ? true : isIntersecting;
      if (this.props.onIntersect && isIntersecting) {
        this.props.onIntersect();
      }
      this.setState({
        isIntersecting,
        didIntersect
      });
    };
    this.renderLoadingState = () => {
      return /*#__PURE__*/_jsx(LoadingDiv, {
        className: "text-center vertical-middle-inline-block",
        height: this.loadingWrapperHeight,
        children: /*#__PURE__*/_jsx(UILoadingSpinner, {})
      });
    };
    this.loadingWrapperHeight = props.loadingWrapperHeight || DEFAULT_LOADING_WRAPPER_HEIGHT;
  }
  render() {
    const {
      children,
      mountOnce
    } = this.props;
    const {
      isIntersecting,
      didIntersect
    } = this.state;
    const showChildren = isIntersecting || didIntersect && mountOnce;
    return /*#__PURE__*/_jsx(Observer, {
      onChange: this.handleChange,
      children: showChildren ? children : this.renderLoadingState()
    });
  }
}
LazyLoadWrapper.propTypes = {
  children: PropTypes.object.isRequired,
  mountOnce: PropTypes.bool.isRequired,
  onIntersect: PropTypes.func,
  loadingWrapperHeight: PropTypes.number
};
export default LazyLoadWrapper;